// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

export default interface ITypeDef {
  name: string;
  content: string[];
}
